/* eslint-disable no-unused-vars */
import React, {
  useContext,
  useState,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import './style.scss';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box, IconButton, Tooltip } from '@mui/material';
import { newTab } from 'src/pages/home';

import { ReactComponent as Send } from 'src/assets/icons/sendPaperPlane.svg';
import { ReactComponent as ConsultaIcon } from 'src/assets/icons/oldPortal/consulta.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';
import { ReactComponent as BoletoIcon } from 'src/assets/icons/boleto.svg';
import { ReactComponent as DowloadIcon } from 'src/assets/icons/download.svg';
import { ReactComponent as AvisoIcon } from 'src/assets/icons/aviso.svg';
import { ReactComponent as LoadIcon } from 'src/assets/icons/loading.svg';
import { ReactComponent as Update } from 'src/assets/icons/bancos/update.svg';
import { ReactComponent as Search } from 'src/assets/icons/bancos/mglass.svg';

import { ReactComponent as Sicredi } from 'src/assets/icons/bancos/sicredi.svg';
import { ReactComponent as BB } from 'src/assets/icons/bancos/bb.svg';
import { ReactComponent as Itau } from 'src/assets/icons/bancos/itau.svg';
import { ReactComponent as Sicoob } from 'src/assets/icons/bancos/sicoob.svg';

import { ReactComponent as DownArrow } from 'src/assets/icons/downArrow.svg';

import CustomInput, { ConsultaInput } from '../customInput';
import {
  CLogin,
  GetTitulosReceberApi,
  CEmite,
  setTitulosApi,
  CVisualiza,
  CPdf,
} from './cobrancaAuth';
import showToast from '../toastyService';
import { LoadGif } from '../LoadGif';
import { isValid } from 'src/services/auth';
import { RenderBinaryPdf, RenderPdf } from 'src/components';

const apiUrl = window.globalConfig.COBRANCA_URL;

export default function Administrativo() {
  const [showPopup, setShowPopup] = useState('');

  const [sendLoad, setSendLoad] = useState(false);
  const [load, setLoad] = useState(false);
  const [dropdown, setDropdown] = useState('');
  const [allDropdown, setAllDropdown] = useState(false);

  function timedLoad(time) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, time);
  }

  const [filtro, setFiltro] = useState({});
  const [titulos, setTitulos] = useState();
  const [contas, setContas] = useState();
  const [newTableData, setNewTableData] = useState([]);

  const [invalidRows, setInvalidRows] = useState({});

  //=-----------------------------------------------------------------------------------=//

  function handleBusca(filtro) {
    setLoad(true);

    GetTitulosReceberApi('GetTitulosReceberAPI', filtro)
      .then((res) => {
        setTitulos(res);
      })
      .catch((error) => showToast('error', error))
      .finally(() => {
        timedLoad(1000);
        setShowPopup('');
      });
  }

  //=-----------------------------------------------------------------------------------=//

  function handleEmite(clickedRow) {
    const thisTitulo = {
      ideemp: clickedRow.ideemp,
      idefil: clickedRow.idefil,
      idcon: clickedRow.consel,
      numtit: clickedRow.numtit,
      vlrabe: clickedRow.vlrabe,
      vlraba: clickedRow.vlraba,
      vctpro: clickedRow.vctpro,
      vctlim: clickedRow.vctlim,
      bolace: clickedRow.bolace,
      msgbol: clickedRow.msgbol,
      nomcli: clickedRow.nomcli,
      tipcli: clickedRow.tipcli,
      cgccpf: clickedRow.cgccpf,
      endcli: clickedRow.endcli,
      cepcli: clickedRow.cepcli,
      cidcli: clickedRow.cidcli,
      baicli: clickedRow.baicli,
      sigufs: clickedRow.sigufs,
      foncli: clickedRow.foncli,
      taxmul: clickedRow.taxmul,
      taxjrs: clickedRow.taxjrs,
      //-----------------------
      codtpt: clickedRow.codtpt,
      codemp: clickedRow.codemp,
      codfil: clickedRow.codfil,
      codcli: clickedRow.codcli,
    };

    if (!isValid(thisTitulo.idcon)) {
      setInvalidRows((prev) => ({
        ...prev,
        [clickedRow.numtit]: true,
      }));
      showToast('error', 'Conta não selecionada');
      return;
    } else {
      setInvalidRows((prev) => {
        const updated = { ...prev };
        delete updated[clickedRow.numtit];
        return updated;
      });
    }

    setSelectedRows((prev) =>
      prev.filter((row) => row.numtit !== clickedRow.numtit)
    );
    setRowSelection((prev) => {
      const newSelection = { ...prev };
      const rowId = clickedRow.numtit;
      delete newSelection[rowId];
      return newSelection;
    });

    setNewTableData((prev) =>
      prev.map((row) =>
        row.numtit === clickedRow.numtit
          ? { ...row, situacaoEmissao: 'PREPARANDO' }
          : row
      )
    );

    setLoad(true);
    CEmite(
      thisTitulo.ideemp,
      thisTitulo.idefil,
      thisTitulo.idcon,
      thisTitulo.numtit,
      thisTitulo.vlrabe,
      thisTitulo.vlraba,
      thisTitulo.vctpro,
      thisTitulo.vctlim,
      thisTitulo.bolace,
      thisTitulo.msgbol,
      thisTitulo.nomcli,
      thisTitulo.tipcli,
      thisTitulo.cgccpf,
      thisTitulo.endcli,
      thisTitulo.cepcli,
      thisTitulo.cidcli,
      thisTitulo.baicli,
      thisTitulo.sigufs,
      thisTitulo.foncli,
      thisTitulo.taxmul,
      thisTitulo.taxjrs,
      setLoad
    )
      .then((res) => {
        handleSetTitulos(
          res,
          thisTitulo.codtpt,
          thisTitulo.codemp,
          thisTitulo.codfil,
          thisTitulo.codcli
        );

        const updateRow = {
          ...clickedRow,
          idefin: res.id,
          sitfin: res.situacaoEmissao,
          situacaoEmissao: res.situacaoEmissao,
        };

        handleConsulta(updateRow);
      })
      .catch((error) => showToast('error', error))
      .finally(() => {
        timedLoad(1000);
      });
  }

  //=-----------------------------------------------------------------------------------=//

  function handleConsulta(clickedRow) {
    if (!isValid(clickedRow.idefin)) {
      showToast('error', 'ID do Boleto Inválida');
      return;
    }

    setNewTableData((prev) =>
      prev.map((row) =>
        row.numtit === clickedRow.numtit
          ? { ...row, situacaoEmissao: 'ATUALIZANDO' }
          : row
      )
    );

    CVisualiza(clickedRow.idefin, setLoad)
      .then((res) => {
        setNewTableData((prev) =>
          prev.map((row) =>
            row.numtit === clickedRow.numtit
              ? { ...row, situacaoEmissao: res.situacaoEmissao }
              : row
          )
        );

        setTitulosApi(
          'SetTitulosReceberAPI',
          clickedRow.codemp,
          clickedRow.codfil,
          clickedRow.codcli,
          clickedRow.numtit,
          clickedRow.codtpt,
          clickedRow.vlrabe,
          clickedRow.vlraba,
          clickedRow.vctpro,
          clickedRow.vctlim,
          clickedRow.bolace,
          clickedRow.msgbol,
          clickedRow.nomcli,
          clickedRow.tipcli,
          clickedRow.cgccpf,
          clickedRow.endcli,
          clickedRow.cepcli,
          clickedRow.cidcli,
          clickedRow.baicli,
          clickedRow.sigufs,
          clickedRow.foncli,
          clickedRow.taxmul,
          clickedRow.taxjrs,
          JSON.stringify(res),
          res.id,
          res.situacaoEmissao,
          clickedRow.UrlBol,
          clickedRow.UrlPdf,
          clickedRow.IdeBil,
          clickedRow.idecon
        )
          .then((res) => {
            showToast('success', 'Titulos Salvos');
          })
          .catch((error) => showToast('error', error))
          .finally(() => {
            timedLoad(1000);
          });
      })
      .catch((error) => console.log('error', error));
  }

  //=-----------------------------------------------------------------------------------=//

  function handlePdf(row) {
    CPdf(44, setLoad)
      .then((res) => {
        if (isValid(res))
          newTab(`Boleto: ${row.numtit}`, <RenderPdf data={res} />);
      })
      .catch((error) => console.log('error', error));
  }

  function handleDowloadPdf(row) {
    CPdf(44, setLoad)
      .then((res) => {
        if (isValid(res)) {
          const link = document.createElement('a');
          link.href = `data:application/pdf;base64,${res}`;
          link.download = `boleto-${row.numtit}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setShowPopup('');
        }
      })
      .catch((error) => console.log('error', error));
  }

  //=-----------------------------------------------------------------------------------=//

  function handleSetTitulos(resposta, codtpt, codemp, codfil, codCli) {
    const thisTitulos = {
      CodTpt: codtpt,
      CodEmp: codemp,
      CodFil: codfil,
      CodCli: codCli,
      IdeCon: resposta.contaBancariaId,
      NumTit: resposta.idIntegracao,
      VlrAbe: resposta.valorTotal,
      VlrAba: resposta.valorAbatimento,
      VctPro: resposta.dataVencimento,
      VctLim: resposta.dataLimitePagamento,
      BolAce: resposta.boletoAceito,
      MsgBol: resposta.mensagemBoleto,
      NomCli: resposta.pagadorNome,
      TipCli: resposta.pagadorTipoPessoa,
      CgcCpf: resposta.pagadorCpfCnpj,
      EndCli: resposta.pagadorEndereco,
      CepCli: resposta.pagadorCep,
      CidCli: resposta.pagadorCidade,
      BaiCli: resposta.pagadorBairro,
      SigUfs: resposta.pagadorUf,
      FonCli: resposta.pagadorTelefone,
      TaxMul: resposta.taxaMulta,
      TaxJrs: resposta.taxaJurosMensal,

      ArqJso: JSON.stringify(resposta),
      IdeFin: resposta.id,
      SitFin: resposta.situacaoEmissao,
    };

    setTitulosApi(
      'SetTitulosReceberAPI',
      thisTitulos.CodEmp,
      thisTitulos.CodFil,
      thisTitulos.CodCli,
      thisTitulos.NumTit,
      thisTitulos.CodTpt,
      thisTitulos.VlrAbe,
      thisTitulos.VlrAba,
      thisTitulos.VctPro,
      thisTitulos.VctLim,
      thisTitulos.BolAce,
      thisTitulos.MsgBol,
      thisTitulos.NomCli,
      thisTitulos.TipCli,
      thisTitulos.CgcCpf,
      thisTitulos.EndCli,
      thisTitulos.CepCli,
      thisTitulos.CidCli,
      thisTitulos.BaiCli,
      thisTitulos.SigUfs,
      thisTitulos.FonCli,
      thisTitulos.TaxMul,
      thisTitulos.TaxJrs,
      thisTitulos.ArqJso,
      thisTitulos.IdeFin,
      thisTitulos.SitFin,
      thisTitulos.UrlBol,
      thisTitulos.UrlPdf,
      thisTitulos.IdeBil,
      thisTitulos.IdeCon
    )
      .then((res) => {
        showToast('success', 'Titulos Salvos');
      })
      .catch((error) => showToast('error', error))
      .finally(() => {
        timedLoad(1000);
      });
  }

  //=-----------------------------------------------------------------------------------=//

  function updateTable() {
    if (titulos?.length > 0) {
      const newRows = titulos
        ?.filter((i) => i.name === 'dadosGerais')
        .map((item) => {
          const dados = item.children.reduce((acc, child) => {
            acc[child.name.toLowerCase()] = child.value;
            return acc;
          }, {});
          dados.situacaoEmissao = dados.sitfin;
          dados.consel = dados.idecon;
          return dados;
        });

      const newContas = titulos
        ?.filter((i) => i.name === 'contasBancarias')
        .map((item) => {
          return item.children.reduce((acc, child) => {
            acc[child.name.toLowerCase()] = child.value;
            return acc;
          }, {});
        });

      setNewTableData(newRows);
      setContas(newContas);
    } else {
      setNewTableData([]);
    }
  }

  useEffect(() => {
    updateTable();
  }, [titulos]);

  //=-----------------------------------------------------------------------------------=//

  const theme = createTheme({
    palette: {
      primary: {
        main: '#0fa697',
      },
      secondary: {
        main: '#0fa697',
      },
    },
    components: {
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            color: '#0b4e5c',
          },
          outlined: {
            borderColor: '#0b4e5c',
          },
          outlinedPrimary: {
            '&.Mui-selected': {
              backgroundColor: '#0b4e5c',
              color: 'white',
            },
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: '#0b4e5c', //checkbox
            '&.Mui-checked': {
              color: '#0b4e5c !important', //checkbox selecionado
            },
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: '#0b4e5c',
            '&.Mui-selected': {
              color: '#0b4e5c !important',
            },
          },
        },
      },
    },
  });

  //=-----------------------------------------------------------------------------------=//

  const columns = [
    {
      accessorKey: 'situacaoEmissao',
      header: 'Status',
    },
    {
      accessorKey: 'numtit',
      header: 'Título',
    },
    {
      accessorKey: 'tipcli',
      header: 'Tipo',
    },
    {
      accessorKey: 'codpor',
      header: 'Portador',
    },
    {
      accessorKey: 'codcrt',
      header: 'Carteira',
    },
    {
      accessorKey: 'nomcli',
      header: 'Cliente',
    },
    {
      accessorKey: 'datemi',
      header: 'Emissão',
    },
    {
      accessorKey: 'vctpro',
      header: 'Vencimento',
    },
    {
      accessorKey: 'qtddia',
      header: 'Dias',
    },
    {
      accessorKey: 'vlrabe',
      header: 'Valor Aberto',
    },
    {
      accessorKey: 'idefin',
      header: 'Id',
    },
    {
      accessorKey: 'emibol',
      header: 'Emitido',
    },
    {
      accessorKey: 'sitfin',
      header: 'Situação',
    },
  ];

  //=-----------------------------------------------------------------------------------=//

  const [selectedDowload, setSelectedDowload] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [rowSelection, setRowSelection] = useState({});

  const isMobile = window.innerWidth <= 768;
  const table = useMaterialReactTable({
    columns,
    data: newTableData,
    enableGlobalFilter: true,
    enableEditing: true,
    editDisplayMode: 'row',
    enableColumnPinning: true,
    enableFullScreenToggle: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    rowPinningDisplayMode: 'top-and-bottom',

    enableRowSelection: (row) => !isValid(row.original.situacaoEmissao),

    getRowId: (row) => row.numtit,
    onRowSelectionChange: setRowSelection,
    state: { rowSelection },

    initialState: {
      showGlobalFilter: true,
      density: 'compact',
      columnPinning: !isMobile
        ? { left: ['mrt-row-select', 'mrt-row-actions'] }
        : {},
      pagination: { pageSize: 15 },
    },

    muiTopToolbarProps: {
      className: 'myTable-toolbar',
    },

    muiSelectCheckboxProps: ({ row }) => ({
      sx: {
        opacity: !isValid(row.original.situacaoEmissao) ? '1' : '0.3',
      },
    }),

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    muiTableContainerProps: {
      sx: {
        flex: 1,
        height: '100%',
        maxHeight: 'calc(100% - 6.5rem)',
        overflow: 'auto',
      },
    },

    muiTableHeadCellProps: ({ column }) => ({
      sx:
        column.id === 'mrt-row-select'
          ? { width: '36px', padding: '0 !important' }
          : {},
    }),

    muiTableBodyCellProps: ({ column, row }) => ({
      sx: {
        overflow: 'visible',
        ...(column.id === 'mrt-row-select' && {
          width: '36px',
          padding: '0 !important',
        }),
        backgroundColor: row.original.corlin || 'transparent',
        '&:before': {
          backgroundColor: `${row.original.corlin} !important`,
        },
      },
    }),

    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        overflow: 'visible',
        cursor: 'pointer',
        backgroundColor:
          row.original.situacaoEmissao === 'PREPARANDO'
            ? '#ebebeb'
            : row.original.situacaoEmissao === 'EMITIDO'
              ? '#e6ffec'
              : row.original.situacaoEmissao === 'PROCESSANDO'
                ? '#dae0e3'
                : row.original.situacaoEmissao === 'ERRO'
                  ? '#ffebd9'
                  : row.original.corlin || 'inherit',
        color: row.original.cortex || 'inherit',
      },
    }),

    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: true,
      variant: 'outlined',
    },

    paginationDisplayMode: 'pages',

    renderRowActions: ({ row, table }) => {
      const conta = contas.find(
        (c) => Number(c.idecon) === Number(row.original.consel)
      );
      const descon = conta?.descon.toUpperCase() || '0';

      return (
        <Box
          sx={{
            display: 'flex',
            gap: '1rem',
            overflow: 'visible',
          }}
        >
          <Tooltip className={`atualizar`} title="Atualizar Registro">
            <IconButton
              className={`${row.original.situacaoEmissao === 'ATUALIZANDO' ? 'active' : ''}`}
              onClick={() => handleConsulta(row.original)}
            >
              <Update className="tableIcon" />
            </IconButton>
          </Tooltip>

          {!isValid(row.original.situacaoEmissao) && (
            <Tooltip className="sendIcon" title="Emitir">
              <IconButton onClick={() => handleEmite(row.original)}>
                <Send className="tableIcon" />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip
            className={`loadIcon ${
              row.original.situacaoEmissao === 'PREPARANDO' ||
              row.original.situacaoEmissao === 'PROCESSANDO'
                ? ''
                : ' hideLoad'
            }
          
          ${row.original.situacaoEmissao === 'PROCESSANDO' ? ' active' : ''}  `}
          >
            <IconButton>
              <LoadIcon className="tableIcon" />
            </IconButton>
          </Tooltip>

          <Tooltip
            className={`boleto`}
            style={{
              display:
                row.original.situacaoEmissao === 'EMITIDO' ? 'flex' : 'none',
            }}
            title="Abrir Pdf"
          >
            <IconButton onClick={() => handlePdf(row.original)}>
              <BoletoIcon className="tableIcon" />
            </IconButton>
          </Tooltip>

          <Tooltip
            style={{
              opacity: row.original.situacaoEmissao === 'EMITIDO' ? '1' : '0',
              pointerEvents:
                row.original.situacaoEmissao === 'EMITIDO' ? 'all' : 'none',
            }}
            className={`dowload`}
            title="Fazer Download do Arquivo"
          >
            <IconButton
              onClick={() => {
                setShowPopup('dowload');
                setSelectedDowload(row.original);
              }}
            >
              <DowloadIcon className="tableIcon" />
            </IconButton>
          </Tooltip>

          <Tooltip
            className={`aviso`}
            style={{
              display:
                row.original.situacaoEmissao === 'ERRO' ? 'flex' : 'none',
            }}
            title="Visualizar Erro"
          >
            <IconButton onClick={() => console.log(row.original)}>
              <AvisoIcon className="tableIcon" />
            </IconButton>
          </Tooltip>

          <div
            className={`conta tipo${descon} ${invalidRows[row.original.numtit] ? 'invalid' : ''} ${dropdown === row.original.numtit ? 'active' : ''}`}
          >
            {descon === 'BB' ? (
              <>
                <BB /> Banco do Brasil
              </>
            ) : descon === 'SICREDI' ? (
              <>
                <Sicredi /> Sicredi
              </>
            ) : descon === 'ITAU' ? (
              <>
                <Itau /> Itau
              </>
            ) : descon === 'SICOOB' ? (
              <>
                <Sicoob /> Sicoob
              </>
            ) : (
              <>
                <DownArrow /> Selecionar Conta
              </>
            )}
            <button
              onClick={() =>
                setDropdown(
                  dropdown === row.original.numtit ? '' : row.original.numtit
                )
              }
              disabled={isValid(row.original.situacaoEmissao)}
            />

            <span
              className={`tableDropdown ${dropdown === row.original.numtit ? 'active' : 'hide'} ${isValid(row.original.situacaoEmissao) ? 'hide' : ''}`}
            >
              <div>
                {contas.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      const updatedData = [...newTableData];
                      updatedData[row.index] = {
                        ...updatedData[row.index],
                        consel: item.idecon,
                      };
                      setNewTableData(updatedData);
                      setDropdown('');
                      setInvalidRows((prev) => {
                        const updated = { ...prev };
                        delete updated[row.original.numtit];
                        return updated;
                      });
                    }}
                    className={`conta tipo${item.descon.toUpperCase()}`}
                  >
                    {item.descon.toUpperCase() === 'BB' ? (
                      <>
                        <BB /> Banco do Brasil
                      </>
                    ) : item.descon.toUpperCase() === 'SICREDI' ? (
                      <>
                        <Sicredi /> Sicredi
                      </>
                    ) : item.descon.toUpperCase() === 'ITAU' ? (
                      <>
                        <Itau /> Itau
                      </>
                    ) : item.descon.toUpperCase() === 'SICOOB' ? (
                      <>
                        <Sicoob /> Sicoob
                      </>
                    ) : (
                      <>
                        <DownArrow /> Selecionar Conta
                      </>
                    )}
                  </button>
                ))}
              </div>
            </span>
          </div>
        </Box>
      );
    },

    localization: {
      ...MRT_Localization_PT_BR,
      noRecordsToDisplay: 'Consulta não efetuada.',
    },
  });

  //=-----------------------------------------------------------------------------------=//

  const allDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        allDropdownRef.current &&
        !allDropdownRef.current.contains(event.target)
      ) {
        setAllDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const selected = Object.keys(rowSelection).map((rowId) =>
      newTableData.find((row) => row.numtit === rowId)
    );
    setSelectedRows(selected);
  }, [rowSelection]);

  //=-----------------------------------------------------------------------------------=//

  const intervalRef = useRef(null);

  useEffect(() => {
    const temProcessando = newTableData.some(
      (l) => l.situacaoEmissao === 'PROCESSANDO'
    );

    if (temProcessando && !intervalRef.current) {
      intervalRef.current = setInterval(() => {
        newTableData.forEach((linha) => {
          if (linha.situacaoEmissao === 'PROCESSANDO') {
            console.log('consultando: ', linha.numtit);
          } else {
            console.log('finalizando: ', linha.numtit);
          }
        });
      }, 5000);
    }

    if (!temProcessando && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [newTableData]);

  //=-----------------------------------------------------------------------------------=//

  return (
    <div className="Cobranca">
      {load && <LoadGif />}

      {(showPopup !== '' || load) && (
        <button onClick={() => setShowPopup('')} className="fade" />
      )}

      {showPopup === 'dowload' && (
        <div className="modal absoluteCenter dowload">
          <p>
            Fazer o download do item: {selectedDowload.numtit} |{' '}
            {selectedDowload.idefin}
          </p>
          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>
            <button
              onClick={() => handleDowloadPdf(selectedDowload)}
              className="mainButton turquoise"
            >
              <Check />
              Download
            </button>
          </div>
        </div>
      )}

      {showPopup === 'consulta' && (
        <div className="modal absoluteCenter consulta">
          <div>
            <div className="grupo">
              <span>Emissão</span>
              <CustomInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    emissaoInicio: newValue.target.value,
                  }))
                }
                Type="date"
                PlaceHolder="Início"
              />
              <CustomInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    emissaoFim: newValue.target.value,
                  }))
                }
                Type="date"
                PlaceHolder="Fim"
              />
            </div>
            <div className="grupo">
              <span>Vencimento</span>
              <CustomInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    vencimentoInicio: newValue.target.value,
                  }))
                }
                Type="date"
                PlaceHolder="Início"
              />
              <CustomInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    vencimentoFim: newValue.target.value,
                  }))
                }
                Type="date"
                PlaceHolder="Fim"
              />
            </div>
            <div className="grupo">
              <span>Valor em Aberto</span>
              <CustomInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    valorInicio: newValue.target.value,
                  }))
                }
                Type="number"
              />
              <CustomInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    valorFim: newValue.target.value,
                  }))
                }
                Type="number"
              />
            </div>
            <ConsultaInput
              OnChange={(newValue) =>
                setFiltro((prev) => ({
                  ...prev,
                  cliente: newValue.target.value,
                }))
              }
              PlaceHolder="cliente"
            />
            <ConsultaInput
              OnChange={(newValue) =>
                setFiltro((prev) => ({
                  ...prev,
                  grupo: newValue.target.value,
                }))
              }
              PlaceHolder="grupo"
            />
          </div>
          <div>
            <div className="grupo">
              <span>Portador/Carteira</span>
              <ConsultaInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    portadorInicio: newValue.target.value,
                  }))
                }
              />
              <ConsultaInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    portadorFim: newValue.target.value,
                  }))
                }
              />
            </div>
            <div className="grupo">
              <span>Tip. Título/Título</span>
              <ConsultaInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    tituloInicio: newValue.target.value,
                  }))
                }
              />
              <ConsultaInput
                OnChange={(newValue) =>
                  setFiltro((prev) => ({
                    ...prev,
                    tituloFim: newValue.target.value,
                  }))
                }
              />
            </div>
            <CustomInput
              OnChange={(newValue) =>
                setFiltro((prev) => ({
                  ...prev,
                  intervalo: newValue.target.value,
                }))
              }
              Type="text"
              PlaceHolder="Intervalo NF"
            />
          </div>

          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>
            <button
              onClick={() => handleBusca(filtro)}
              className="mainButton turquoise"
              disabled={
                !(
                  (filtro.emissaoInicio && filtro.emissaoFim) ||
                  (filtro.vencimentoInicio && filtro.vencimentoFim)
                )
              }
            >
              <Check />
              Buscar
            </button>
          </div>
        </div>
      )}

      <div className="tableMenu">
        <button
          className="mainButton yellow"
          onClick={() => {
            setFiltro({});
            setShowPopup('consulta');
          }}
        >
          <ConsultaIcon />
          Consultar
        </button>

        {selectedRows.length > 0 && (
          <div className={`conta tipo0`}>
            <button onClick={() => setAllDropdown(!allDropdown)} />
            <DownArrow /> Selecionar
            <span
              ref={allDropdownRef}
              className={`allDropdown ${allDropdown ? 'active' : 'hide'}`}
            >
              <div>
                {contas.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setAllDropdown(false);
                      setNewTableData((prev) =>
                        prev.map((thisItem) =>
                          selectedRows.some(
                            (row) => row.numtit === thisItem.numtit
                          )
                            ? { ...thisItem, consel: item.idecon }
                            : thisItem
                        )
                      );
                    }}
                    className={`conta tipo${item.descon.toUpperCase()}`}
                  >
                    {item.descon.toUpperCase() === 'BB' ? (
                      <>
                        <BB /> Banco do Brasil
                      </>
                    ) : item.descon.toUpperCase() === 'SICREDI' ? (
                      <>
                        <Sicredi /> Sicredi
                      </>
                    ) : item.descon.toUpperCase() === 'ITAU' ? (
                      <>
                        <Itau /> Itau
                      </>
                    ) : item.descon.toUpperCase() === 'SICOOB' ? (
                      <>
                        <Sicoob /> Sicoob
                      </>
                    ) : (
                      <>
                        <DownArrow /> Selecionar Conta
                      </>
                    )}
                  </button>
                ))}
              </div>
            </span>
          </div>
        )}
        {selectedRows.length > 0 && (
          <button
            className="mainButton enviarTodos"
            onClick={() => {
              newTableData.forEach((item) => {
                if (selectedRows.some((row) => row.numtit === item.numtit)) {
                  handleEmite(item);
                }
              });
            }}
          >
            <Send />
            Enviar Todos
          </button>
        )}
      </div>

      <div className="tableWrapper">
        <ThemeProvider theme={theme}>
          <MaterialReactTable table={table} />
        </ThemeProvider>
      </div>

      <div
        style={{
          display: 'none',
          position: 'absolute',
          bottom: '0',
          left: '0',
          zIndex: '30',
        }}
      >
        <button
          style={{ height: '2rem' }}
          className="mainButton gray"
          onClick={() => {
            console.log('titulos: ', titulos);
            console.log('newTableData: ', newTableData);
            console.log('contas: ', contas);
            console.log('invRows: ', invalidRows);
            console.log('selectedRows: ', selectedRows);
          }}
        >
          <ConsultaIcon />
          test
        </button>
        <button
          style={{ height: '2rem' }}
          className="mainButton red"
          onClick={() => {
            localStorage.removeItem('CToken');
          }}
        >
          <ConsultaIcon />
          remover token
        </button>
      </div>
    </div>
  );
}
